"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getThemeData = exports.parseTheme = void 0;
var Themes_1 = require("../constants/Themes");
/**
 * Taken from ACE editor
 */
var rgbColor = function (color) {
    var _a, _b, _c, _d;
    if (!color || color === null)
        return undefined;
    // TODO: support color objects
    // if (typeof color === 'object') return color;
    if (color[0] === '#') {
        return (_b = (_a = color
            .match(/^#(..)(..)(..)/)) === null || _a === void 0 ? void 0 : _a.slice(1)) === null || _b === void 0 ? void 0 : _b.map(function (hex) { return parseInt(hex, 16); });
    }
    return (_d = (_c = color
        .match(/\(([^,]+),([^,]+),([^,]+)/)) === null || _c === void 0 ? void 0 : _c.slice(1)) === null || _d === void 0 ? void 0 : _d.map(function (rgb) { return parseInt(rgb, 10); });
};
var darkness = function (color) {
    var rgb = rgbColor(color);
    if (!rgb)
        return 1;
    return (0.21 * rgb[0] + 0.72 * rgb[1] + 0.07 * rgb[2]) / 255;
};
var parseColor = function (color) {
    var _a, _b;
    if (!color.length)
        return null;
    // eslint-disable-next-line no-param-reassign
    if (color.length === 4)
        color = color.replace(/[a-fA-F\d]/g, '$&$&');
    if (color.length === 7)
        return color;
    if (color.length === 9)
        return color; // substr(0, 7);
    // eslint-disable-next-line no-console
    if (!color.match(/^#(..)(..)(..)(..)$/))
        console.error("can't parse color", color);
    var rgba = (_b = (_a = color
        .match(/^#(..)(..)(..)(..)$/)) === null || _a === void 0 ? void 0 : _a.slice(1)) === null || _b === void 0 ? void 0 : _b.map(function (c) { return parseInt(c, 16); });
    if (!rgba)
        return undefined;
    rgba[3] = (rgba[3] / 0xff).toPrecision(2);
    return "rgba(".concat(rgba.join(', '), ")");
};
/* Mapped from vscode/src/vs/workbench/services/themes/electron-browser/themeCompatibility.ts */
var COLOR_MAP = [
    {
        tm: 'foreground',
        mn: 'editor.foreground',
    },
    {
        tm: 'background',
        mn: 'editor.background',
    },
    {
        tm: 'selection',
        mn: 'editor.selectionBackground',
    },
    {
        tm: 'inactiveSelection',
        mn: 'editor.inactiveSelectionBackground',
    },
    {
        tm: 'selectionHighlightColor',
        mn: 'editor.selectionHighlightBackground',
    },
    {
        tm: 'findMatchHighlight',
        mn: 'editor.findMatchHighlightBackground',
    },
    {
        tm: 'currentFindMatchHighlight',
        mn: 'editor.findMatchBackground',
    },
    {
        tm: 'hoverHighlight',
        mn: 'editor.hoverHighlightBackground',
    },
    {
        tm: 'wordHighlight',
        mn: 'editor.wordHighlightBackground',
    },
    {
        tm: 'wordHighlightStrong',
        mn: 'editor.wordHighlightStrongBackground',
    },
    {
        tm: 'findRangeHighlight',
        mn: 'editor.findRangeHighlightBackground',
    },
    {
        tm: 'findMatchHighlight',
        mn: 'peekViewResult.matchHighlightBackground',
    },
    {
        tm: 'referenceHighlight',
        mn: 'peekViewEditor.matchHighlightBackground',
    },
    {
        tm: 'lineHighlight',
        mn: 'editor.lineHighlightBackground',
    },
    {
        tm: 'rangeHighlight',
        mn: 'editor.rangeHighlightBackground',
    },
    {
        tm: 'caret',
        mn: 'editorCursor.foreground',
    },
    {
        tm: 'invisibles',
        mn: 'editorWhitespace.foreground',
    },
    {
        tm: 'guide',
        mn: 'editorIndentGuide.background',
    },
    {
        tm: 'activeGuide',
        mn: 'editorIndentGuide.activeBackground',
    },
    {
        tm: 'selectionBorder',
        mn: 'editor.selectionHighlightBorder',
    },
];
var ansiColorMap = [
    'ansiBlack',
    'ansiRed',
    'ansiGreen',
    'ansiYellow',
    'ansiBlue',
    'ansiMagenta',
    'ansiCyan',
    'ansiWhite',
    'ansiBrightBlack',
    'ansiBrightRed',
    'ansiBrightGreen',
    'ansiBrightYellow',
    'ansiBrightBlue',
    'ansiBrightMagenta',
    'ansiBrightCyan',
    'ansiBrightWhite',
];
ansiColorMap.forEach(function (color) {
    COLOR_MAP.push({
        tm: color,
        mn: "terminal.".concat(color),
    });
});
/**
 * @param {string | object} rawTheme - The contents of a theme file
 * @returns {IStandaloneThemeData} A monaco compatible theme definition.
 * See https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.istandalonethemedata.html
 */
var parseTheme = function (rawTheme) {
    var theme = typeof rawTheme === 'object' ? rawTheme : JSON.parse(rawTheme);
    var globalSettings = theme.colors || {};
    var rules = [];
    theme.tokenColors.forEach(function (setting) {
        var _a, _b;
        var scopes;
        if (typeof setting.scope === 'string') {
            scopes = setting.scope.replace(/^[,]+/, '').replace(/[,]+$/, '').split(',');
        }
        else if (Array.isArray(setting.scope)) {
            scopes = setting.scope;
        }
        else {
            scopes = [''];
        }
        var rule = {};
        var settings = setting.settings;
        if (settings.foreground) {
            rule.foreground = (_a = parseColor(settings.foreground)) === null || _a === void 0 ? void 0 : _a.toLowerCase().replace('#', '');
        }
        if (settings.background) {
            rule.background = (_b = parseColor(settings.background)) === null || _b === void 0 ? void 0 : _b.toLowerCase().replace('#', '');
        }
        if (settings.fontStyle && typeof settings.fontStyle === 'string') {
            rule.fontStyle = settings.fontStyle;
        }
        scopes.forEach(function (scope) {
            if (!scope || !Object.keys(rule).length) {
                return;
            }
            var r = __assign(__assign({}, rule), { token: scope.trim() });
            rules.push(r);
        });
    });
    var globalColors = {};
    /* More properties to be added */
    COLOR_MAP.forEach(function (obj) {
        if (globalSettings[obj.tm]) {
            globalColors[obj.mn] = parseColor(globalSettings[obj.tm]);
        }
        else if (globalSettings[obj.mn]) {
            globalColors[obj.mn] = parseColor(globalSettings[obj.mn]);
        }
    });
    return {
        base: darkness(globalColors['editor.background']) < 0.5 ? 'vs-dark' : 'vs',
        inherit: true,
        rules: rules,
        colors: globalColors,
    };
};
exports.parseTheme = parseTheme;
var getThemeData = function (theme) {
    var _a = Themes_1.CustomThemes[theme], data = _a.data, standalone = _a.standalone;
    if (!data) {
        return undefined;
    }
    if (standalone) {
        return data;
    }
    return (0, exports.parseTheme)(data);
};
exports.getThemeData = getThemeData;
